import axios from 'axios'
import _ from 'lodash'
import { FilterIcon, RotateCcwIcon, XCircleIcon } from 'vue-feather-icons'

import emptyDeliveriesImage from '@/assets/images/empty_deliveries.png'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import AddDeliveryRequestStart from '@/vcs/_shared/modals/add-delivery-request-start/cmp.vue'
import AddFrontexDeliveryRequestStart from '@/vcs/_shared/modals/frontex-delivery/add-delivery-request-start/cmp.vue'

import DeliveryRequest from './delivery-request/cmp.vue'
import FilterButton from './FilterButton.vue'
import SearchInput from './SearchInput.vue'

const PAGE_SIZE = 20

export default {
  name: 'Delivery',
  mixins: [CurrentUserResolver],
  components: {
    RotateCcwIcon,
    XCircleIcon,
    FilterIcon,
    DeliveryRequest,
    FilterButton,
    SearchInput,
    SearchInfo: () => import('./DeliveryRequestSearchInfo.vue'),
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
  data: function () {
    return {
      drs: {
        user: [],
        delivererOutgoing: [],
        delivererIncoming: [],
      },
      collectomates: [],

      deliveryScenario: 'by_deliverer', // by_user, by_deliverer
      outgoing: false,

      isSearchVisible: false,
      isSearchOverlayVisible: false,
      searchFiled: '',
      deafaultSearch: {},
      search: {
        user: {
          text: '',
          statusIn: [],
        },
        delivererOutgoing: {
          text: '',
          statusIn: [],
        },
        delivererIncoming: {
          text: '',
          statusIn: [],
        },
      },

      emptyDeliveriesImage: emptyDeliveriesImage,
      blocker: false,
    }
  },
  created() {
    window.mainApp.$on(`updateDeliveryRequests`, this.fetchDRs)
  },
  beforeDestroy() {
    window.mainApp.$off(`updateDeliveryRequests`)
  },
  mounted() {
    this.fetchDRs()
  },
  computed: {
    scenarioKey() {
      // 'user', 'delivererOutgoing', 'delivererIncoming' - these keys are based on active scenario. This helps us accessing search object.
      if (this.isUserScenario) {
        return 'user'
      } else if (this.isDelivererOutgoingScenario) {
        return 'delivererOutgoing'
      } else if (this.isDelivererIncomingScenario) {
        return 'delivererIncoming'
      }
    },
    filteredItems() {
      return this.drs[this.scenarioKey]
    },
    displayUserScenarioTab() {
      return this.drs.user.length || this.hasUserScenarioCPs
    },
    displayOutgoingDelivererScenarioTab() {
      return this.drs.delivererOutgoing.length || this.hasDelivererScenarioCPs
    },
    incoming() {
      return !this.outgoing
    },
    isUserScenario() {
      return this.deliveryScenario == 'by_user'
    },
    isDelivererOutgoingScenario() {
      return this.deliveryScenario == 'by_deliverer' && this.outgoing
    },
    isDelivererIncomingScenario() {
      return this.deliveryScenario == 'by_deliverer' && this.incoming
    },
    hasUserScenarioCPs() {
      return !!this.collectomates.filter(cp => cp.deliveryScenarios.indexOf('by_user') != -1).length
    },
    hasDelivererScenarioCPs() {
      return !!this.collectomates.filter(cp => cp.deliveryScenarios.indexOf('by_deliverer') != -1)
        .length
    },
    collectomateAppUrl() {
      return `${this.$redirectUrl()}/redirected_from_client_app/?user={"id":"${
        this.currentUser.id
      }","email":"${this.currentUser.email}","name":"${this.currentUser.name}","phone":"${
        this.currentUser.phone
      }"}`
    },
  },
  methods: {
    searchText() {
      return this.search[this.scenarioKey].text
    },
    async fetchDRs() {
      this.blocker = true

      try {
        const userSearch = {
          text: '',
          statusIn: [
            'brand_new',
            'started_completion',
            'service_required',
            'completed',
            'not_collected',
          ],
          page: 0,
          userId: this.currentUser.id,
          deliverySecenario: 'by_user',
        }

        const delivererIncomingSearch = {
          text: '',
          statusIn: ['started_completion', 'service_required', 'completed', 'not_collected'],
          page: 0,
          userId: this.currentUser.id,
          outgoing: false, // reciver_id_eq: params[:user_id]
          deliverySecenario: 'by_deliverer',
        }

        let delivererOutgoingSearch = {
          text: '',
          statusIn: ['service_required', 'completed', 'collected', 'not_collected'],
          page: 0,
          userId: this.currentUser.id,
          outgoing: true, // sender_id_eq: params[:user_id]
          deliverySecenario: 'by_deliverer',
        }

        if (this.$isFrontex) {
          delivererOutgoingSearch = {
            text: '',
            statusIn: [
              'started_completion', // dodane
              'service_required',
              'completed',
              'collected',
              'not_collected',
            ],
            page: 0,
            userId: this.currentUser.id,
            outgoing: true, // sender_id_eq: params[:user_id]
            deliverySecenario: 'by_deliverer',
          }
        }

        const userScenarioDRs = await this.fetchDeliveryRequests(userSearch)
        const outgoingDelivererScenarioDRs = await this.fetchDeliveryRequests(
          delivererOutgoingSearch,
        )
        const incomingDelivererScenarioDRs = await this.fetchDeliveryRequests(
          delivererIncomingSearch,
        )
        const collectomates = await this.fetchCollectomates()

        // apply data
        this.search.user = userSearch
        this.search.delivererOutgoing = delivererOutgoingSearch
        this.search.delivererIncoming = delivererIncomingSearch

        this.search = { ...this.search }
        this.deafaultSearch.user = { ...this.search.user }
        this.deafaultSearch.delivererOutgoing = {
          ...this.search.delivererOutgoing,
        }
        this.deafaultSearch.delivererIncoming = {
          ...this.search.delivererIncoming,
        }

        this.drs.user = userScenarioDRs.data
        this.drs.delivererOutgoing = outgoingDelivererScenarioDRs.data
        this.drs.delivererIncoming = incomingDelivererScenarioDRs.data
        this.collectomates = collectomates.data
      } catch (error) {
        this.$errorHumanized({ error })
      } finally {
        this.blocker = false
      }
    },
    async fetchDeliveryRequests(
      options = {
        page: 0,
        userId: '',
        deliverySecenario: '',
        outgoing: null,
        text: '',
      },
    ) {
      const { page, userId, deliverySecenario, outgoing, statusIn, text } = options
      return axios({
        method: 'get',
        url: 'delivery_requests',
        params: {
          page,
          delivery_scenario: deliverySecenario,
          page_size: PAGE_SIZE,
          user_id: userId,
          outgoing: outgoing,
          status_in: statusIn,
          text: text,
        },
      })
    },
    async fetchCollectomates() {
      return axios({
        method: 'get',
        url: 'collection_points',
      })
    },
    loadMoreDrs() {
      // this.page = newPage
      if (this.isUserScenario) {
        this.blocker = true
        const search = {
          ...this.search.user,
          ...{ page: this.search.user.page + 1 },
        }

        this.fetchDeliveryRequests(search)
          .then(response => {
            this.search.user = { ...search }
            this.drs.user = [...this.drs.user, ...response.data]
          })
          .finally(() => {
            this.blocker = false
          })
      } else if (this.isDelivererOutgoingScenario) {
        this.blocker = true
        const search = {
          ...this.search.delivererOutgoing,
          ...{ page: this.search.delivererOutgoing.page + 1 },
        }

        this.fetchDeliveryRequests(search)
          .then(response => {
            this.search.delivererOutgoing = { ...search }
            this.drs.delivererOutgoing = [...this.drs.delivererOutgoing, ...response.data]
          })
          .finally(() => {
            this.blocker = false
          })
      } else if (this.isDelivererIncomingScenario) {
        this.blocker = true
        const search = {
          ...this.search.delivererIncoming,
          ...{ page: this.search.delivererIncoming.page + 1 },
        }

        this.fetchDeliveryRequests(search)
          .then(response => {
            this.search.delivererIncoming = { ...search }
            this.drs.delivererIncoming = [...this.drs.delivererIncoming, ...response.data]
          })
          .finally(() => {
            this.blocker = false
          })
      }
    },
    // search
    resetSearchHandler() {
      // freeze statusIn's
      const userStatusIn = [...this.search.user.statusIn]
      const delivererOutgoingStatusIn = [...this.search.delivererOutgoing.statusIn]
      const delivererIncomingStatusIn = [...this.search.delivererIncoming.statusIn]

      this.search.user = {
        ...this.deafaultSearch.user,
        ...{ statusIn: userStatusIn },
      }
      this.search.delivererOutgoing = {
        ...this.deafaultSearch.delivererOutgoing,
        ...{ statusIn: delivererOutgoingStatusIn },
      }
      this.search.delivererIncoming = {
        ...this.deafaultSearch.delivererIncoming,
        ...{ statusIn: delivererIncomingStatusIn },
      }

      this.fetchDeliveryRequests(this.search[this.scenarioKey]).then(response => {
        this.handleReponseBasedOnScenarioKey({
          scenarioKey: this.scenarioKey,
          response: response,
        })
      })
    },
    openSearch() {
      this.isSearchVisible = true
      this.isSearchOverlayVisible = true
    },
    closeSearch() {
      this.isSearchVisible = false
      this.isSearchOverlayVisible = false
    },
    closeSearchOverlay() {
      this.isSearchOverlayVisible = false
      this.isSearchVisible = false
    },
    updateSearchTextHandler: _.debounce(function (event) {
      this.updateSearchTextAndFetch({ text: event.target.value })
    }, 300),
    updateSearchTextAndFetch(options) {
      this.blocker = true
      this.search[this.scenarioKey].text = options.text
      this.search[this.scenarioKey].page = 0
      this.search = { ...this.search }

      this.fetchDeliveryRequests(this.search[this.scenarioKey])
        .then(response => {
          this.handleReponseBasedOnScenarioKey({
            scenarioKey: this.scenarioKey,
            response: response,
          })
        })
        .finally(() => {
          this.blocker = false
        })
    },
    // other
    openAddDeliveryModalInUserScenario() {
      this.$store.commit('modal/open', {
        cmp: AddDeliveryRequestStart,
        animation: 'slide-down-menu',
      })
    },
    openAddDeliveryModalInDelivererOutgoingScenario() {
      this.$store.commit('modal/open', {
        cmp: AddFrontexDeliveryRequestStart,
        animation: 'slide-down-menu',
      })
    },
    showUserScenarioDRs() {
      this.deliveryScenario = 'by_user'
    },
    showOutgoingDelivererScenarioDRs() {
      this.deliveryScenario = 'by_deliverer'
      this.outgoing = true
    },
    showIncomingDelivererScenarioDRs() {
      this.deliveryScenario = 'by_deliverer'
      this.outgoing = false
    },
    satusInChangeHandler(data) {
      console.log('statuses recived', data.statusIn)
      this.search[this.scenarioKey].statusIn = data.statusIn
      this.search[this.scenarioKey].page = 0
      this.search = { ...this.search }

      this.blocker = true
      this.fetchDeliveryRequests(this.search[this.scenarioKey])
        .then(response => {
          this.handleReponseBasedOnScenarioKey({
            scenarioKey: this.scenarioKey,
            response: response,
          })
        })
        .finally(() => {
          this.blocker = false
        })
    },
    handleReponseBasedOnScenarioKey(args) {
      const { scenarioKey, response } = args

      this.drs[scenarioKey] = response.data
      this.drs = { ...this.drs }
    },
  },
}
